<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "附件添加" : "附件添加" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='400'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <div class="mb-6 size-15">原文件：{{item.data.fileName}}</div>
          <file-upload
            label="政策文件,支持pdf文件"
            :rules="required"
            outlined
            prepend-icon=''
            accept=".pdf"
            :bucket='bucket'
            @on-upload='onUpload'
            :lazy="false"
          />
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import FileUpload from '@/components/oss/Index.vue'
  import { save } from '@/api/policy/index.js'

  export default {
    name: 'PolicyFile',
    components: {
      FileUpload
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        files: null,
        loading: false,
        required: [
          value => (!!value || value === 0) || '此项为必填项!'
        ],
        bucket: 'yd-policy',
        form: {
          id: '',
          fileName: ''
        }
      }
    },
    methods: {
      onUpload (file, boo) {
        this.form.fileName = `${this.bucket}/${file.name}`
        if (boo) {
          this.form.id = this.item.data.id
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
